import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

function AdminAjoutMarque() {
  const [fournisseurs, setFournisseurs] = useState([]);
  const [newMarque, setNewMarque] = useState();
  const [entite_Id, setEntite_Id] = useState(1);
  const history = useHistory();

  const TOKEN_KEY = "jwt";
  const token = localStorage.getItem(TOKEN_KEY);

  useEffect(() => {
    function getFournisseurs() {
      axios.get(`${API_URL}/api/fournisseurs`).then((res) => {
        setFournisseurs(res.data);
      });
    }

    getFournisseurs();
  }, []);

  const handleChange = (e) => {
    const { value } = e.target;
    setNewMarque(() => value);
  };

  function handleSubmit() {
    axios
      .post(
        `${API_URL}/api/marques/`,
        { newMarque, entite_Id },
        {
          headers: {
            authorization: `Bearer ${token}`,
          },
        }
      )
      .then(() => {
        alert("Création effectuée !");
        history.push("/backoffice/home");
      })
      .catch((e) => {
        console.error(e);
        alert(`Erreur : ${e.message}`);
      });
  }

  return (
    <div>
      <input type="text" onChange={handleChange} />
      <select onChange={(e) => setEntite_Id(e.target.value)}>
        {fournisseurs.map((a) => (
          <option value={a.id} key={a.id}>
            {a.nom}{" "}
          </option>
        ))}
      </select>
      <button type="button" onClick={() => handleSubmit()}>
        Enregistrer
      </button>
    </div>
  );
}

export default AdminAjoutMarque;
